import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setChannelTab } from '../../features/ui/uiSlice';

import { useSummaryQuery, useLeadsSummaryQuery, useAccountsSummaryQuery } from '../../services/api';
import SegmentedTabs from '../../components/common/SegmentedTabs';
import { ShimmerText } from '../../components/common/Shimmer';
import ChannelDashboard from './ChannelDashboard';
import LedgerTab from './LedgerTab';
import LeadsTab from './leads/LeadsTab';
import AccountsTab from './accounts/AccountsTab';

export default function ChannelPage({ channelId }) {
  const dispatch = useAppDispatch();
  const { channelTab, range } = useAppSelector((s) => s.ui);
  const { data: accountStats } = useAccountsSummaryQuery({ channel: channelId });
  const { data: summary } = useSummaryQuery({ range, channel: channelId });
  // shares the leads tab's cache key, so the badge costs no extra request
  const { data: leadStats } = useLeadsSummaryQuery({ channel: channelId });
  const rowCount = summary?.current?.n;

  return (
    <>
      <SegmentedTabs
        sx={{ mb: 2.25 }}
        value={channelTab}
        onChange={(v) => {
          dispatch(setChannelTab(v));
          window.scrollTo(0, 0);
        }}
        items={[
          { value: 'dashboard', label: '▦ Dashboard' },
          { value: 'leads', label: '◆ Leads', count: leadStats ? leadStats.total : <ShimmerText chars={2} /> },
          { value: 'accounts', label: '★ Accounts', count: accountStats ? accountStats.total : <ShimmerText chars={2} /> },
          { value: 'ledger', label: '☰ Ledger', count: rowCount ?? <ShimmerText chars={3} /> },
        ]}
      />
      {channelTab === 'leads' && <LeadsTab channelId={channelId} />}
      {channelTab === 'accounts' && <AccountsTab channelId={channelId} />}
      {channelTab === 'ledger' && <LedgerTab channelId={channelId} />}
      {channelTab === 'dashboard' && <ChannelDashboard channelId={channelId} />}
    </>
  );
}
